var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.sizeOptionKey
    ? _c(
        "div",
        {
          staticClass: "product-item__sizes",
          on: { click: _vm.toggleSwatches }
        },
        [
          _c("p", { staticClass: "body-small" }, [
            _vm._v("\n    " + _vm._s(_vm.sizesTitle) + "\n  ")
          ]),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "product-item__sizes-list" },
            [
              _vm._l(_vm.sizes, function(size, index) {
                return _vm.sizes.length
                  ? _c("li", { key: index }, [
                      _c(
                        "a",
                        {
                          class: _vm.getSizeClasses(size),
                          attrs: { disabled: !_vm.getSizeClasses(size) },
                          on: {
                            click: function(event) {
                              return _vm.addToCart(size, event)
                            }
                          }
                        },
                        [_vm._v("\n        " + _vm._s(size) + "\n      ")]
                      )
                    ])
                  : _vm._e()
              }),
              _vm._v(" "),
              !_vm.sizes.length
                ? _c("li", { key: 0 }, [
                    _c(
                      "a",
                      {
                        class: _vm.getSizeClasses("One Size"),
                        attrs: { disabled: !_vm.getSizeClasses("One Size") },
                        on: {
                          click: function(event) {
                            return _vm.addToCart("One Size", event)
                          }
                        }
                      },
                      [_vm._v("\n        One Size\n      ")]
                    )
                  ])
                : _vm._e()
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }